import { render, staticRenderFns } from "./more-info.vue?vue&type=template&id=e5a47080"
import script from "./more-info.vue?vue&type=script&lang=js"
export * from "./more-info.vue?vue&type=script&lang=js"
import style0 from "./more-info.vue?vue&type=style&index=0&id=e5a47080&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports